<template>
  <div id="distribution_stu">
    <h2 style="font-size: 24px; color: #262626; font-weight: bold;">学生测评</h2>
    <div>
      <div class="item_one">
        <span style="font-size: 18px; font-weight: bold; display: block; margin: 24px 0px 16px;">测评推荐</span>
        <div class="flex_part" v-if="recommendNum">
          <div v-for="(item, index) in recommendNum" :key="index + 're'" class="recom_box" @click="recomHand(recommendList[item-1], item)">
            <img :src="recommendList[item-1].img" alt="">
            <div class="recom_con">
              <span style="font-size: 16px; font-weight: bold;">{{recommendList[item-1].title}}</span>
              <span style="font-size: 12px; color: #8C8C8C;">{{recommendList[item-1].con}}</span>
            </div>
          </div>
        </div>
      </div>
      <a-drawer
        placement="right"
        :closable="false"
        :visible="showDrawer"
        :after-visible-change="afterVisibleChange"
        @close="onClose"
        width="770"
      >
        <scale-drawer @drawerVisible="drawerVisibleHand" :scaleText="scaleInfo"></scale-drawer>
      </a-drawer>
      <div class="item_two">
        <span style="font-size: 18px; font-weight: bold; display: block; margin: 24px 0px 16px;">绿萝量表库</span>
        <div class="ku_box flex_part">
          <div class="ku_warp flex_part">
            <div v-if="completeNumber">
              <div style="margin-top: 30px;">截止到今日，学校共完成了<span class="ku_num">{{totalNum}}</span>次测评任务</div>
              <div style="margin: 8px 0px;">帮助<span class="ku_num">{{stuTotal}}</span>位学生完成了<span class="ku_num">{{completeNumber.complete_num}}</span>次测评</div>
              <div style="margin-bottom: 30px;">超越了系统中<span class="ku_num">{{completeNumber.complete_num ? completeNumber.ratio_per : 0}}%</span>的学校</div>
            </div>
            <img src="@/assets/ku_icon02.png" alt="">
          </div>
          <div class="ku_warp flex_part">
            <div>
              <div class="ku_title flex_part"><span></span><b>常见问题</b></div>
              <a href="https://www.yuque.com/docs/share/f430b30f-bdef-4370-96a3-b676b5007e5b?# 《如何创建测评任务？》" target="_blank">我如何创建测评任务？</a>
              <a href="https://www.yuque.com/docs/share/fddd7817-ba56-419c-afc5-604ae680516d?# 《学校能拿到那些报告？》" target="_blank">我能拿到什么报告？</a>
              <a href="https://www.yuque.com/docs/share/62df6ca5-eca5-4be6-ade4-1a339627c8a0?# 《组织学生测评时需要注意什么？》" target="_blank">组织学生测评时需要注意什么？</a>
            </div>
            <img src="@/assets/ku_icon01.png" alt="">
          </div>
        </div>
        <div class="ku_table">
          <scale-type></scale-type>
        </div>
      </div>
      <div class="item_three">
        <span style="font-size: 18px; font-weight: bold; display: block; margin: 24px 0px 16px;">量表小知识</span>
        <div class="know_box flex_part">
          <div v-for="(item, index) in knowledgeList" :key="index + 'kn'" class="know_warp" @click="linkHandle(item.link)">
            <div>
              <img :src="item.img" alt="">
            </div>
            <span style="display: block; width: 200px; margin-top: 16px;">{{item.title}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ScaleType from './ScaleType'
import ScaleDrawer from './ScaleDrawer'
import RecommendArr from '@/util/RecommendList'

export default {
  name: 'DistributionStu',
  components: {
    ScaleType,
    ScaleDrawer
  },
  data () {
    return {
      showDrawer: false,
      recommendNum: null,
      scaleInfo: null,
      totalNum: null,
      recommendList: [
        {
          img: require('@/assets/recommend_icon01.png'),
          title: '心理危机筛查（小学）',
          con: '了解学生的心理健康状态',
          scaleId: 993544,
          surveyTitle: '青少年心理危机筛查量表（小学版）',
          surveyNum: 94,
          surveyTime: 30,
          surveyLink: JSON.parse(sessionStorage.getItem('userInfo')).city === 450900 ? 'https://www.yuque.com/bndawg/sddy0x/peucrgs4c9nk24cd?singleDoc# 《青少年心理危机筛查量表V2023（小学版）》' : 'https://www.yuque.com/docs/share/4f1f8982-55c8-4ee8-b103-67beea299d3b?# 《青少年心理危机筛查量表（小学版）》',
          surveyCon: '青少年心理危机筛查量表通过一个量表（6个部分）对三大心理指标（心理症状、心理韧性、心理压力）进行测量，其中，第1部分为13道测量社会期许水平的题目，同时，量表中设置4道测查数据有效性的题目在第5部分和第6部分，总共为102道题目。可以有效的通过测评对学生的心理健康水平进行反馈，帮助学校了解学生的心理健康状态，并及时的进行干预和辅导，确保学生健康成长。'
        },
        {
          img: require('@/assets/recommend_icon08.png'),
          title: '心理危机筛查（初高中）',
          con: '了解学生的心理健康状态',
          scaleId: 993541,
          surveyTitle: '青少年心理危机筛查量表（初高中）',
          surveyNum: 102,
          surveyTime: 30,
          surveyLink: JSON.parse(sessionStorage.getItem('userInfo')).city === 450900 ? 'https://www.yuque.com/bndawg/sddy0x/sck3eqz0g2koo1r1?singleDoc# 《青少年心理危机筛查量表V2023（初高中）》' : 'https://www.yuque.com/docs/share/2037c7d7-d30a-4392-b606-e31213aceaa0?# 《青少年心理危机筛查量表（初高中）》',
          surveyCon: '青少年心理危机筛查量表通过一个量表（6个部分）对三大心理指标（心理症状、心理韧性、心理压力）进行测量，其中，第1部分为13道测量社会期许水平的题目，同时，量表中设置4道测查数据有效性的题目在第5部分和第6部分，总共为102道题目。可以有效的通过测评对学生的心理健康水平进行反馈，帮助学校了解学生的心理健康状态，并及时的进行干预和辅导，确保学生健康成长。'
        },
        {
          img: require('@/assets/recommend_icon02.png'),
          title: '创造力测评',
          con: '发现有创造性的个体',
          scaleId: 568797,
          surveyTitle: '威廉斯创造力倾向测试量表',
          surveyNum: 50,
          surveyTime: 15,
          surveyLink: 'https://www.yuque.com/docs/share/bb6d246e-ffb8-4ba7-8107-395625236d49?# 《威廉斯创造力倾向测试量表》',
          surveyCon: '威廉斯创造力倾向测试量表是由美国的创造力教学研究专家威廉斯设计的，主要测试好奇心、想象力、挑战性和冒险性四项个性特质水平。该量表共50道题目，可以较好地被应用于发现那些有创造性的个体。测验适合中小学生及以上人群。'
        },
        {
          img: require('@/assets/recommend_icon03.png'),
          title: '学习风格测评',
          con: '了解学生的不同学习风格',
          scaleId: 832898,
          surveyTitle: 'Soloman学习风格量表',
          surveyNum: 44,
          surveyTime: 15,
          surveyLink: 'https://www.yuque.com/docs/share/149373a0-d5c1-4b2e-a632-b405951b3e4e?# 《Soloman学习风格量表》',
          surveyCon: '学生的学习成绩除了与学生的个人能力密切相关外，还与学生在学习时的心理因素密切相关。其中，学生的学习风格就是一个重要的影响因素。本平台提供soloman学习风格量表，帮助老师快速了解每个学生不同的学习风格，进而优化教学方法，帮助学生快速找到适合自己的学习方法。',
          surveyConTwo: 'Soloman学习风格量表共44道题目，配备个体、班级、年级报告，通过测评，能够了解到每位学生属于以下四组中的哪种类型：活跃型/沉思型、感悟型/直觉型、视觉型/听觉型、序列型/整体型；老师也可以综合评估班级及年级中各种学习风格类型学生的占比，多角度多层面的了解学生的学习风格，更好的开展后续的教学工作。'
        },
        {
          img: require('@/assets/recommend_icon04.png'),
          title: '学业情绪测评',
          con: '了解学生在学习中的情绪',
          scaleId: 993539,
          surveyTitle: '青少年学业情绪问卷',
          surveyNum: 72,
          surveyTime: 18,
          surveyLink: 'https://www.yuque.com/docs/share/efc0c16f-0b3b-43ac-ac0a-93d5822898bd?# 《青少年学业情绪问卷》',
          surveyCon: '学业情绪(academic emotions)是指学生在学业情境中的事件所激发的情绪，包括学习过程或考试中所体验到的各种情绪，如完成老师交给的学习任务时的喜悦；考试失败时的羞愧等。'
        },
        {
          img: require('@/assets/recommend_icon05.png'),
          title: '多元智能测评',
          con: '了解学生的优势智能',
          scaleId: 993540,
          surveyTitle: '多元智能量表（简版）',
          surveyNum: 45,
          surveyTime: 15,
          surveyLink: 'https://www.yuque.com/docs/share/4e45bae2-43b4-4cd0-8858-37fb49461543?# 《多元智能量表（简版）》',
          surveyCon: '《多元智能评估量表》根据加德纳的多元智能理论的最新进展编制而成，采用自我参照与群体参照相结合，自评与他评三角互证的方式对测评对象的优势智能表现进行综合评估。该量表为自评量表，共45个条目，包括语言智能、数学-逻辑智能、视觉空间智能、身体运动智能、音乐智能、人际智能、自我认识智能、自然观察智能和存在智能9个方面，适用于小学三年级及以上的人群使用。'
        },
        {
          img: require('@/assets/recommend_icon06.png'),
          title: '社交焦虑测评',
          con: '筛查儿童社交焦虑症状',
          scaleId: 143921,
          surveyTitle: '儿童社交焦虑量表(SASC)',
          surveyNum: 10,
          surveyTime: 3,
          surveyLink: 'https://www.yuque.com/docs/share/50b29296-23aa-4708-8506-d7cdc13b2ca0?# 《儿童社交焦虑量表(SASC)》',
          surveyCon: '儿童社交焦虑量表（Social Anxiety Scale for Children , SASC）是La Greca编制的一种儿童社交焦虑症状的筛查量表, 用于评估儿童焦虑性障碍, 可作为辅助临床诊断、科研及流行病学调查的筛查工具。该量表的信度与效度较好, 是一种有效的筛选工具, 可为临床儿童社交焦虑性障碍的诊断提供帮助。'
        },
        {
          img: require('@/assets/recommend_icon07.png'),
          title: '霍兰德职业测评',
          con: '了解符合学生的职业类型',
          scaleId: 335811,
          surveyTitle: '霍兰德职业兴趣测评量表（60题简版）',
          surveyNum: 60,
          surveyTime: 15,
          surveyLink: 'https://www.yuque.com/docs/share/05ea5e53-b31d-4377-92cc-13fca443d241?# 《霍兰德职业兴趣测量表（60题简版）》',
          surveyCon: '生涯教育是学生学习生活中非常重要的一环，只有确立了明确的目标，学习才会更有方向和动力。本平台提供霍兰德职业兴趣测验，通过测评，学生可以通过自己擅长或者感兴趣的方面发现和确定自己的职业兴趣和能力专长, 从而对未来将从事的职业及专业做出科学的选择。',
          surveyConTwo: '霍兰德职业兴趣测验由美国著名职业指导专家 Ｊ.霍兰德（ＨＯＬＬＡＮＤ）编制的, 在几十年间经过一百多次大规模的实验研究，最终形成了人格类型与职业类型的学说和测验。本量表共60道题目，根据学生的测评结果将给出更符合该生的职业类型（社会型、常规型、企业型、艺术型、调研型和实际型）和职业建议，帮助学生提前树立明确目标，对自己未来的职业生涯做出合理的规划。'
        }
      ],
      knowledgeList: [
        {
          img: require('@/assets/wen_tu01.jpg'),
          title: '中小学生为什么要做心理测评？',
          link: 'https://zhuanlan.zhihu.com/p/370398254'
        },
        {
          img: require('@/assets/wen_tu02.jpg'),
          title: '智商测试能反映孩子的智力吗?',
          link: 'https://zhuanlan.zhihu.com/p/370386056'
        }
      ]
    }
  },
  computed: {
    ...mapState([
      'schoolGrades',
      'questionnairenTask',
      'schoolTaskScale',
      'stuTotal',
      'completeNumber',
      'teacherAdmin',
      'userInfo'
    ])
  },
  async mounted () {
    this.recommendNum = RecommendArr(this.schoolGrades)
    let arr = this.schoolTaskScale.filter(item => item.type !== 1)
    if (this.userInfo.type === 2) {
      this.totalNum = arr.length
    } else {
      this.totalNum = this.questionnairenTask.length + arr.length
    }
    await this.getCompleteNum()
  },
  methods: {
    ...mapActions([
      'getCompleteNum'
    ]),
    recomHand (key, id) {
      this.scaleInfo = key
      this.scaleInfo['id'] = id
      this.showDrawer = true
    },
    drawerVisibleHand (key) {
      this.showDrawer = key
    },
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    onClose() {
      this.showDrawer = false
    },
    linkHandle (url) {
      window.open(url)
    }
  }
}
</script>

<style>
#distribution_stu {
  width: 100%;
  color: #262626;
}
#distribution_stu .flex_part {
  display: flex;
}
#distribution_stu .flex_part .recom_box {
  flex-basis: 25%;
  cursor: pointer;
  margin-right: 16px;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  transition: all 0.5s;
}
#distribution_stu .flex_part .recom_box:last-child {
  margin-right: 0px;
}
#distribution_stu .flex_part .recom_box img {
  width: 100%;
  height: auto;
}
#distribution_stu .flex_part .recom_box .recom_con {
  padding: 16px;
  box-sizing: border-box;
}
#distribution_stu .flex_part .recom_box .recom_con span {
  display: block;
}
#distribution_stu .ku_box {
  align-items: flex-start;
}
#distribution_stu .ku_box .ku_warp {
  flex-basis: 50%;
  margin-right: 16px;
  padding: 0px 24px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  align-items: center;
  justify-content: space-between;
}
#distribution_stu .ku_box .ku_warp:last-child {
  margin-right: 0px;
}
#distribution_stu .ku_box .ku_warp .ku_num {
  font-size: 24px;
  color: #51BF94;
  margin: 0px 8px;
}
#distribution_stu .ku_box .ku_warp img {
  width: 94px;
  height: auto;
}
#distribution_stu .ku_box .ku_warp .ku_title {
  align-items: center;
  margin: 24px 0px;
}
#distribution_stu .ku_box .ku_warp .ku_title span {
  display: inline-block;
  width: 4px;
  height: 14px;
  margin-right: 8px;
  background-color: #51BF94;
}
#distribution_stu .ku_box .ku_warp a {
  display: block;
  color: #262626;
  margin-bottom: 16px;
}
#distribution_stu .ku_box .ku_warp a:visited, #distribution_stu .ku_box .ku_warp a:active, #distribution_stu .ku_box .ku_warp a:link {
  text-decoration: none;
}
#distribution_stu .ku_box .ku_warp a:hover {
  color:  #51BF94;
}
#distribution_stu .ku_box .ku_warp a:last-child {
  margin-bottom: 20px;
}
#distribution_stu .ku_table {
  width: 100%;
  margin-top: 16px;
}
#distribution_stu .know_box img {
  width: 200px;
  height: 110px;
}
#distribution_stu .know_box .know_warp {
  height: 280px;
  margin-right: 16px;
  cursor: pointer;
  padding: 16px 16px 0px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  transition: all 0.5s;
}
#distribution_stu .know_box .know_warp:hover, #distribution_stu .flex_part .recom_box:hover {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
}
#distribution_stu .know_box .know_warp:last-child {
  margin-right: 0px;
}
#distribution_stu .item_three {
  margin-bottom: 60px;
}
</style>
